<div class="pdf-modal-overlay">
  <div class="editor-header d-flex justify-content-between align-items-center p-3 text-white">
    <div class="d-flex align-items-center gap-3">
      <h5 class="title_five mb-0">Edit PDF</h5>
      <div class="vr mx-2"></div>
      <!-- <button class="btn btn-outline-secondary btn-sm" (click)="addText()">
        <i class="pi pi-pencil text-icon"></i>
        <span class="ms-1">Add Text</span>
      </button>

      <button class="btn btn-outline-secondary btn-sm" (click)="logoInput.click()">
        <i class="pi pi-image text-icon"></i>
        <span class="ms-1">Add Image</span>
      </button>
      <input #logoInput type="file" hidden (change)="onLogoUpload($event)" accept="image/*"> -->

      <!-- <button *ngIf="isCurrentPageLandscape" class="btn btn-outline-secondary btn-sm" (click)="rotatePdf()">
        <i class="pi pi-refresh text-icon ms-1"></i>
        <span class="ms-1">Rotate</span>
      </button> -->
      <button *ngIf="hasLandscapePages" class="btn btn-outline-primary btn-sm ms-2" (click)="rotateAllLandscape()" pTooltip="Rotate     landscape pages to portrait">
        <i class="pi pi-sync text-icon ms-1"></i>
        <span class="ms-1">Rotate All</span>
      </button>
    </div>

    <div class="custom_button d-flex gap-2">
      <p-button (click)="onCancel.emit()" label="Discard Changes" styleClass="p-button-sm"></p-button>
      <p-button (click)="finalizePdf()" label="Finalize & Save" styleClass="p-button-sm-outline"></p-button>
    </div>
  </div>

  <div class="editor-body">
    <div class="canvas-viewport" id="pdf-container" (click)="deselect($event)" (scroll)="checkCurrentPageOrientation()">
      <div class="pdf-scroll-wrapper">
        <div class="pdf-stage shadow-lg">
          <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="true" [show-all]="true"
            (page-rendered)="onPageRendered()" [autoresize]="true" class="pdf-viewer-container"
            [style.height.px]="pdfViewerHeight" [style.min-width.px]="900">
          </pdf-viewer>

          <div class="annotation-layer">
            <div *ngFor="let item of annotations; let i = index; trackBy: trackById" cdkDrag
              [cdkDragBoundary]="'.annotation-layer'" [cdkDragFreeDragPosition]="{ x: item.x, y: item.y }"
              (cdkDragStarted)="selectItem(i)" (cdkDragEnded)="onDragEnd($event, i)"
              [class.active-item]="selectedIndex === i" class="draggable-annotation">

              <div *ngIf="item.type === 'text'" class="text-render" [style.fontSize.px]="item.fontSize">{{ item.value }}
              </div>
              <img *ngIf="item.type === 'image'" [src]="item.value" [style.width.px]="item.width">
              <div class="selection-border" *ngIf="selectedIndex === i"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="properties-sidebar p-3 bg-light border-start">
      <h6 class="text-muted small fw-bold text-uppercase mb-4">Properties</h6>
      <div *ngIf="selectedItem; else noSelection">
        <ng-container *ngIf="selectedItem.type === 'text'">
          <div class="mb-3">
            <label class="form-label small">Text Content</label>
            <input type="text" class="form-control" [value]="selectedItem.value"
              (input)="updateSelected({ value: $any($event.target).value })">
          </div>
          <div class="mb-3">
            <label class="form-label small">Font Size</label>
            <input type="range" class="form-range" min="8" max="72" [value]="selectedItem.fontSize"
              (input)="updateSelected({ fontSize: +$any($event.target).value })">
            <div class="text-end extra-small">{{ selectedItem.fontSize }}px</div>
          </div>
        </ng-container>
        <ng-container *ngIf="selectedItem.type === 'image'">
          <div class="mb-3">
            <label class="form-label small">Image Width (px)</label>
            <input type="range" class="form-range" min="30" max="400" [value]="selectedItem.width"
              (input)="updateSelected({ width: +$any($event.target).value })">
            <div class="text-end extra-small">{{ selectedItem.width }}px</div>
          </div>
        </ng-container>
        <hr>
        <button class="btn btn-sm btn-outline-danger w-100" (click)="removeSelected()">Delete Layer</button>
      </div>
      <ng-template #noSelection>
        <div class="text-center mt-5 text-muted italic">
          <p>Click an element to edit</p>
        </div>
      </ng-template>
    </div>
  </div>
</div>